import { Preferences } from '../../profile/objects/preferences';
import { Column } from '../../cms/objects/column';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';
import {
    LOCKABLE_FARE_PARAMETER_DEFAULT_COLUMNS,
    LOCKABLE_FARE_PARAMETER_MODULE,
} from '../constant/lockableFareParameterConstant';

export const setLockableFareParameterPreference = (
    new_preferences: Preferences[],
    state_columns: Column[],
): ListPreferenceResult => setListPreference(new_preferences, state_columns, {
    module: LOCKABLE_FARE_PARAMETER_MODULE,
    default_columns: LOCKABLE_FARE_PARAMETER_DEFAULT_COLUMNS,
    default_order: 'asc',
});
